import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import orderReducer from './order';
import featureFlagsReducer from './featureFlags';

export const initialState = {};

const rootReducer = combineReducers({
  // Reducers here
  order: orderReducer,
  featureFlags: featureFlagsReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export type AppDispatch = typeof store.dispatch;

export default store;
